/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_1_ProblemInputs */

const et_portfolio_project_1_problem = /** @type {(inputs: Portfolio_Project_1_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 aastat vana veebileht Google'i 5. lehel, mis ei genereerinud praktiliselt ühtegi päringut.`)
};

const en_portfolio_project_1_problem = /** @type {(inputs: Portfolio_Project_1_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdated 20-year-old website ranking on page 5 of Google, generating almost zero inquiries.`)
};

/**
* | output |
* | --- |
* | "Outdated 20-year-old website ranking on page 5 of Google, generating almost zero inquiries." |
*
* @param {Portfolio_Project_1_ProblemInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_1_problem = /** @type {((inputs?: Portfolio_Project_1_ProblemInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_1_ProblemInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_1_problem(inputs)
	return en_portfolio_project_1_problem(inputs)
});